import { render } from "./video-category.vue?vue&type=template&id=017d9050&scoped=true"
import script from "./video-category.vue?vue&type=script&lang=js"
export * from "./video-category.vue?vue&type=script&lang=js"

import "./video-category.vue?vue&type=style&index=0&id=017d9050&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-017d9050"]])

export default __exports__